export const globalStatsUrl =
  "https://metabase.immersion-facile.beta.gouv.fr/public/dashboard/93afb41e-949d-4677-aab3-95817f81223d";

export const immersionStatsUrl =
  "https://metabase.immersion-facile.beta.gouv.fr/public/dashboard/531a7757-5e85-4ed7-a958-94f4b493a11a";
